
import {serializable, alias, object, list, primitive} from 'serializr';

export class TotalProductEmissionAnnual { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('name', primitive()))
	name?: string;

	@serializable(alias('total_value', primitive()))
	totalValue?: number;

}